










import { Component, Mixins } from 'vue-property-decorator'

import BaseFileInput from '../../../File/BaseFileInput/BaseFileInput.vue'
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput } from '../../mixins'

@Component({
  components: {
    FieldWrapper,
    BaseFileInput,
  },
})
export default class FileInput extends Mixins(BaseInput) {

}
